import 'leaflet/dist/leaflet.css';

import {createApp} from 'vue';
import {createPinia} from 'pinia';

import {keycloakAPI} from '@/assets/keycloak';

import App from './App.vue';
import {getRouter, initRouter} from './router';
import {initMainAppWorker} from '@/workers/notifications/mainApp';
import {install as VueMonacoEditorPlugin} from '@guolao/vue-monaco-editor';

keycloakAPI.init().then(() => {
  initRouter();
  createApp(App)
    .use(createPinia())
    .use(getRouter())
    .use(VueMonacoEditorPlugin, {
      paths: {
        vs: 'https://cdn.jsdelivr.net/npm/monaco-editor@0.43.0/min/vs',
      },
    })
    .mount('#app');

  initMainAppWorker();
});
